import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllExpandPanelHeaderComponent } from './bll-expand-panel-header.component';
import { BllExpandPanelComponent } from './bll-expand-panel.component';
import { BllExpandComponent } from './bll-expand.component';

@NgModule({
	imports: [CommonModule],
	declarations: [BllExpandComponent, BllExpandPanelComponent, BllExpandPanelHeaderComponent],
	exports: [BllExpandComponent, BllExpandPanelComponent, BllExpandPanelHeaderComponent],
})
export class BllExpandModule {}
